﻿import {errorToErrorBundle, translation} from "@2d-front-monorepo/core";
import {ReactNode} from "react";

export interface FallbackProps {
	error: any;
	resetErrorBoundary: (...args: any[]) => void;
}

export default function DefaultErrorFallback({error, resetErrorBoundary}: FallbackProps): ReactNode {
	const data = errorToErrorBundle(error);
	return <div className="application-error">
		<div>
			<h1>:(</h1>
			<h2>The application ran into a problem and need your attention. We have already collected some error
				info:</h2>
			<h3>{translation(data.title)}</h3>
			{data.detail ? <p className="application-error__detail">{translation(data.detail)}</p> : null}
			{data.footer ? <p className="application-error__footer">{translation(data.footer)}</p> : null}
			<div className="application-error__button">
				<button onClick={resetErrorBoundary}>Restart application</button>
			</div>
			{data.errors.length > 0 ?
				<ul className="application-error__errors">
					{data.errors.map((errorMessage) =>
						<li key={errorMessage.text}>{translation(errorMessage)}</li>)
					}
				</ul>
				: null}
			{data.stack ? <div className="application-error__stack-trace"><code>
				<pre>{data.stack}</pre>
			</code></div> : null}
		</div>
	</div>;
}
